import { MultiMapExportAdequacyCombination } from "@app/projects/network-assessment/multi-map-export/interfaces";
import { countMaps } from "@app/projects/network-assessment/multi-map-export/utils/mapCountSelection";
import { MultiMapExportState } from "@app/projects/network-assessment/multi-map-export/state-management/multiMapExportStateManagement";

export const REPORT_NAME_MAX_LENGTH = 255;

export const isReportNameValid = (reportName?: string): boolean => {
  const trimmed = reportName?.trim() ?? "";

  return trimmed.length > 0 && trimmed.length <= REPORT_NAME_MAX_LENGTH;
};

/**
 * Each section's own requirement, plus the map count. Both are needed: every axis can be filled in while
 * no analysed combination matches all three, which would enable the button with nothing to render.
 *
 * A count of zero also keeps the button disabled while the combinations load, which is intended.
 */
export const canCreateMaps = (
  selections?: MultiMapExportState,
  combinations?: readonly MultiMapExportAdequacyCombination[],
): boolean =>
  isReportNameValid(selections?.reportName)
  && !!selections?.selectedMapType
  && (selections?.selectedCountyRegionSetIds?.length ?? 0) > 0
  // Check the SSAs too, not just the ids: the server reads an empty SSA list as "every county".
  && (selections?.selectedCountySsas?.length ?? 0) > 0
  && (selections?.selectedSpecialtyGroupCodes?.length ?? 0) > 0
  && (selections?.selectedAdequacyOutcomes?.length ?? 0) > 0
  && countMaps(selections, combinations) > 0;
